export const ENTORNO = 'produccionHTTPS';

const localSolimeno = {
    url: '//localhost',
    port: '3001',
    realTimeServerUrl: '//localhost',
    realTimeServerPort: '3001'
}

const produccionSolimeno = {
    url: 'http://52.33.31.178',
    port: '3000',
    realTimeServerUrl: 'http://52.33.31.178',
    realTimeServerPort: '3000'
}

const produccionHTTPS = {
    url: 'https://portalproveedores.solimenosa.com.ar',
    realTimeServerUrl: 'https://portalproveedores.solimenosa.com.ar'
}

export function getRealTimeServerURL() {

    switch (ENTORNO) {
        case 'localSolimeno':
            return `${localSolimeno.realTimeServerUrl}:${localSolimeno.realTimeServerPort}`;
            break;
        case 'produccionSolimeno':
            return `${produccionSolimeno.realTimeServerUrl}:${produccionSolimeno.realTimeServerPort}`;
            break;
        case 'produccionHTTPS':
            return `${produccionHTTPS.realTimeServerUrl}`;
            break;
    }
}

export function getServerURL() {

    switch (ENTORNO) {
        case 'localSolimeno':
            return `${localSolimeno.url}:${localSolimeno.port}/api`;
            break;
        case 'produccionSolimeno':
            return `${produccionSolimeno.url}:${produccionSolimeno.port}/api/`;
            break;
        case 'produccionHTTPS':
            return `${produccionHTTPS.url}/api/`;
            break;
    }
}